// ------------------------------------
// CORES
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'css-variables';

    // Cor primária
    function changePrimaryColor() {
      const color = confTheme[ref]['primary-color'];
      $root[0].style.setProperty('--primary-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-primary-color', changePrimaryColor);

    // Cor secundária
    function changeSecondaryColor() {
      const color = confTheme[ref]['secondary-color'];
      $root[0].style.setProperty('--secondary-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-secondary-color', changeSecondaryColor);

    // Botão primário (Cor de fundo)
    function changeBtnPrimaryBgColor() {
      const color = confTheme[ref]['btn-primary-bg-color'];
      $root[0].style.setProperty('--btn-primary-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-primary-bg-color', changeBtnPrimaryBgColor);

    // Botão primário (Cor do texto)
    function changeBtnPrimaryTxtColor() {
      const color = confTheme[ref]['btn-primary-txt-color'];
      $root[0].style.setProperty('--btn-primary-txt-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-primary-txt-color', changeBtnPrimaryTxtColor);

    // Botão secundário (Cor de fundo)
    function changeBtnSecondaryBgColor() {
      const color = confTheme[ref]['btn-secondary-bg-color'];
      $root[0].style.setProperty('--btn-secondary-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-secondary-bg-color', changeBtnSecondaryBgColor);

    // Botão secundário (Cor do texto)
    function changeBtnSecondaryTxtColor() {
      const color = confTheme[ref]['btn-secondary-txt-color'];
      $root[0].style.setProperty('--btn-secondary-txt-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-secondary-txt-color', changeBtnSecondaryTxtColor);

    // Botão compra (Cor de fundo)
    function changeBtnBuyBgColor() {
      const color = confTheme[ref]['btn-buy-bg-color'];
      $root[0].style.setProperty('--btn-buy-bg-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-buy-bg-color', changeBtnBuyBgColor);

    // Botão compra (Cor do texto)
    function changeBtnBuyTxtColor() {
      const color = confTheme[ref]['btn-buy-txt-color'];
      $root[0].style.setProperty('--btn-buy-txt-color', color);
    }
    $root.on(confEvtDefault + ' lp-evt-btn-buy-txt-color', changeBtnBuyTxtColor);
  }
})();

// ------------------------------------
// CÓDIGOS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'codes';
    const refEvtPrefix = 'lp-evt-';

    // Altera o css customizado
    function changeCssCustom() {
      const code = confTheme[ref]['custom-css'];
      $('#custom-css style').text(code);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'custom-css', changeCssCustom);
  }
})();
